module.exports = __webpack_public_path__ + "static/media/bdl.5ebe6ef3.svg";